export class MediaSize {
    constructor(width, height) {
        this.width = width;
        this.height = height;
    }
}
export class CIDMedia {
    constructor(size, type) {
        this.size = size;
        this.type = type;
    }
}
export class PrinterConfiguration {
    constructor() {
        this.disconnectonpause = true;
        this.connectonresume = true;
        this.lowbatterythreshold = 2;
    }
}
//# sourceMappingURL=configuration.js.map